/**
 * Adds catalog price + ex GST (smaller, below) to Searchanise widgets,
 * matching snippets/price-gst-pair.liquid.
 */
(function () {
  const GST_RATE = 10;
  const PRICE_SELECTOR = [
    '.snize-ac-results .snize-price',
    '.snize-search-results .snize-price',
    '#snize_results .snize-price',
    '.snize-product .snize-price',
    '.snize-product-price',
    '.snize-quick-view .snize-price',
  ].join(',');
  const SKIP_CLOSEST = '.snize-old-price, .snize-discounted-price, del, s';
  const SNIZE_EVENTS = [
    'Searchanise.AutocompleteUpdated',
    'Searchanise.ResultsUpdated',
    'Searchanise.RecommendationUpdated',
    'Searchanise.QuickViewUpdated',
  ];

  let scheduled = null;
  let enhancing = false;
  let jqueryBound = false;

  function getConfig() {
    return window.mhGstDisplay || null;
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = precision == null ? 2 : precision;
    thousands = thousands == null ? ',' : thousands;
    decimal = decimal == null ? '.' : decimal;
    if (isNaN(number) || number == null) return '0';

    const parts = (number / 100).toFixed(precision).split('.');
    const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    const cents = parts[1] ? decimal + parts[1] : '';
    return dollars + cents;
  }

  function formatMoney(cents, format) {
    const formatString = format || '${{amount}}';
    const placeholder = formatString.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!placeholder) return formatString;

    let value;
    switch (placeholder[1]) {
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'", '.');
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }

    return formatString.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  function parsePriceToCents(text) {
    const cleaned = String(text).replace(/\s*(inc|ex)\s*GST/gi, '');
    const match = cleaned.match(/-?[\d.,]+/);
    if (!match) return null;

    let raw = match[0];
    const lastComma = raw.lastIndexOf(',');
    const lastDot = raw.lastIndexOf('.');
    if (lastComma > lastDot) {
      raw = raw.replace(/\./g, '').replace(',', '.');
    } else {
      raw = raw.replace(/,/g, '');
    }

    const num = parseFloat(raw);
    if (isNaN(num)) return null;
    return Math.round(num * 100);
  }

  function extractMoneyString(text) {
    const match = String(text).match(/(?:[A-Z]{3}\s*)?(?:\$|£|€|¥)?\s*-?[\d.,]+(?:\s*[A-Z]{3})?/);
    return match ? match[0].trim() : '';
  }

  function shouldSkipPrice(el) {
    if (!el || el.nodeType !== 1) return true;
    if (el.querySelector('.price-gst')) return true;
    if (el.classList.contains('snize-old-price') || el.classList.contains('snize-discounted-price')) {
      return true;
    }
    if (el.closest(SKIP_CLOSEST)) return true;
    if (el.querySelector('.snize-price, .snize-product-price')) return true;

    const style = window.getComputedStyle(el);
    if (style && style.textDecorationLine && style.textDecorationLine.indexOf('line-through') !== -1) {
      return true;
    }

    return false;
  }

  function enhancePrice(el) {
    if (shouldSkipPrice(el)) return;

    const text = (el.textContent || '').replace(/\s+/g, ' ').trim();
    if (!text || /inc\s*GST/i.test(text) || /ex\s*GST/i.test(text)) return;

    const cents = parsePriceToCents(text);
    if (cents == null || cents <= 0) return;

    const cfg = getConfig();
    if (!cfg) return;

    const taxesIncluded = cfg.taxesIncluded !== false;
    const incCents = taxesIncluded ? cents : Math.round((cents * (100 + GST_RATE)) / 100);
    const exCents = taxesIncluded ? Math.round((cents * 100) / (100 + GST_RATE)) : cents;
    const originalMoney = extractMoneyString(text) || formatMoney(cents, cfg.moneyFormat);
    const incFormatted = taxesIncluded ? originalMoney : formatMoney(incCents, cfg.moneyFormat);
    const exFormatted = formatMoney(exCents, cfg.moneyFormat);
    const exLabel = cfg.exLabel || 'ex GST';
    const fromLabel = cfg.fromLabel || 'From';
    const showFrom = /^\s*from\b/i.test(text);

    let html = '<span class="price-gst">';
    if (showFrom) {
      html += '<span class="price-item__from">' + escapeHtml(fromLabel) + '</span>';
    }
    html +=
      '<span class="price-gst__inc">' +
      escapeHtml(incFormatted) +
      '</span>' +
      '<span class="price-gst__ex">' +
      escapeHtml(exFormatted) +
      ' <span class="price-gst__label">' +
      escapeHtml(exLabel) +
      '</span></span></span>';

    el.innerHTML = html;
  }

  function enhance(root) {
    if (enhancing || !getConfig()) return;

    const scope = root && root.querySelectorAll ? root : document;
    enhancing = true;
    try {
      scope.querySelectorAll(PRICE_SELECTOR).forEach(enhancePrice);
    } finally {
      enhancing = false;
    }
  }

  function scheduleEnhance(root) {
    if (enhancing) return;
    const target = root;
    if (scheduled) clearTimeout(scheduled);
    scheduled = setTimeout(function () {
      scheduled = null;
      enhance(target || document);
    }, 40);
  }

  function bindSearchaniseJquery() {
    if (jqueryBound) return;
    const $ = window.Searchanise && window.Searchanise.$;
    if (!$ || typeof $.fn === 'undefined') return;

    jqueryBound = true;
    $(document).on(SNIZE_EVENTS.join(' '), function () {
      scheduleEnhance(document);
    });
  }

  function nodeLooksLikeSnize(node) {
    if (!node) return false;
    if (node.nodeType === 3) node = node.parentElement;
    if (!node || node.nodeType !== 1) return false;

    const id = node.id ? String(node.id).toLowerCase() : '';
    const className = typeof node.className === 'string' ? node.className.toLowerCase() : '';
    if (id.indexOf('snize') !== -1 || className.indexOf('snize') !== -1) return true;

    return !!(node.closest && node.closest('[class*="snize"], [id*="snize"]'));
  }

  function init() {
    bindSearchaniseJquery();
    enhance(document);

    document.addEventListener('Searchanise.Loaded', function () {
      bindSearchaniseJquery();
      enhance(document);
    });

    SNIZE_EVENTS.forEach(function (eventName) {
      document.addEventListener(eventName, function () {
        scheduleEnhance(document);
      });
    });

    const observer = new MutationObserver(function (mutations) {
      if (enhancing) return;

      for (let i = 0; i < mutations.length; i++) {
        const mutation = mutations[i];
        if (nodeLooksLikeSnize(mutation.target)) {
          scheduleEnhance(document);
          return;
        }

        const nodes = mutation.addedNodes;
        if (!nodes || !nodes.length) continue;
        for (let j = 0; j < nodes.length; j++) {
          if (nodeLooksLikeSnize(nodes[j])) {
            scheduleEnhance(document);
            return;
          }
        }
      }
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
